import React from 'react';

import Radio from '../radio';
import { RadioPersonProps } from './types';
import AddPopup from './addPopup';
import { getRadioValue } from './_util';

// 表单 输入框组件
function RadioPerson(props: RadioPersonProps) {
  const { value, defaultValue, prefixCls = 'crm-radio-person', theme, title, ...rest } = props;
  const { addLabel, _crengine } = props;

  // radio 特定模式强制替换
  if (_crengine && _crengine.dataBind) {
    _crengine.dataBind = 'value';
  }

  const initialValue = getRadioValue(value || defaultValue);

  return (
    <div className={prefixCls}>
      {theme === 'panel' && <div className={`${prefixCls}-theme-panel-header`}>{title}</div>}
      <Radio {...rest} defaultValue={getRadioValue(defaultValue)} value={getRadioValue(value)} />
      {addLabel && addLabel.name === initialValue ? <AddPopup {...props} /> : null}
    </div>
  );
}

export default RadioPerson;
